"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uniq_1 = __importDefault(require("./uniq"));
const mapSkillToCategory_1 = __importDefault(require("./mapSkillToCategory"));
exports.default = (skills, cb) => {
    return uniq_1.default(skills.map(skill => cb(mapSkillToCategory_1.default(skill))))
        .sort()
        .filter(Boolean)
        .join(', ');
};
//# sourceMappingURL=mapSkillsToCategoriesString.js.map